import { put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import {
  REQUEST,
  triggerSuccess,
  triggerFailure
} from '../../actions/forecasts/trigger';
import { fetchRequest as fetchForecastsList } from '../../actions/forecasts/list';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

export function* triggerForecastRequest(action) {
  try {
    const { modelId } = action.payload || {};
    
    if (!modelId) {
      throw new Error('Model ID is required to trigger a forecast');
    }
    
    // Get headers using the utility function
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    // Add content type header
    headers['Content-Type'] = 'application/json';
    
    // Make the API call
    const response = yield axios.post(`${config.API_URL}/forecast/trigger_forecast`, 
      { model_id: modelId },
      { headers }
    );
    
    // If successful, dispatch the success action
    yield put(triggerSuccess(response.data.data));
    
    // Add success snackbar message
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Forecast triggered successfully' });
    
    // Refresh the forecasts list
    yield put(fetchForecastsList());
    
  } catch (error) {
    // If there's an error, dispatch the error action
    yield put(ErrorAction(error));
    yield put(triggerFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, triggerForecastRequest);
} 